module.exports = __webpack_public_path__ + "static/media/26-10.4b7f4508.mp3";